import { Avatar, Grid, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import TextFieldComponent from "../../Components/TextFieldComponent";
import Btn from "../../Components/Ui_elements/Btn";
import {  resetPassword } from "../../redux/Thunk/authThunk/login";
import logo from "../../assets/logo/kanhasoft.png"
import APP_CONFIG_URL_ENV from "../../env-config";

function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();  
    const [token, setToken] = useState('');  // State for token

    const { loading } = useSelector((state) => state.root.loading);
      
    useEffect(() => {
        const tokenParam = location.pathname.split("/").pop(); // Get token from the URL path
        if (tokenParam) setToken(tokenParam);
      }, [location]);

    const LoginSchema = Yup.object().shape({
        password: Yup.string().required("Password is required"),
    });

    const handleSubmit = (values) => {
        dispatch(resetPassword({resetToken: token, newPassword: values.password }))
            .unwrap()
            .then(() => {
                // You can navigate or show a success toast here
                navigate("/login");
            })
            .catch((err) => {
                console.error("Error sending reset password:", err);
            });
    };

    return (
        <>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{
                    height: "100vh",
                    backgroundColor: "#f4f6f8",
                    padding: 3,
                }}
            >
                <Grid item xs={12} md={4} sx={{
                        backgroundColor: "white",
                        borderRadius: 2,
                        boxShadow: 3,
                        padding: 4,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Avatar
                        src={ `${APP_CONFIG_URL_ENV.REACT_APP_FILEPATH}/images/logo.png`}
                        alt="logo"
                        variant="square"
                        style={{
                            width: "183px",
                            height: "auto",
                            margin: "20px auto"
                        }}
                    />
                    <Typography variant="h5" sx={{ textAlign: "center", fontWeight: 600, marginBottom: 3 }}>
                        Reset Password
                    </Typography>

                    <Formik
                        initialValues={{ password: "" }}
                        validationSchema={LoginSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
                                    <Typography variant="body1" sx={{ textAlign: "center", width: "100%" }}>
                                        Enter your new password
                                    </Typography>
                                    <Grid item xs={12}>
                                        <TextFieldComponent
                                            name="password"
                                            type="password"
                                            fullWidth
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isNotMandatory={true}
                                            placeholder="New Password"
                                            error={errors.password && touched.password && errors.password}
                                        />
                                    </Grid>
                                </Grid>

                                <Btn
                                    type="submit"
                                    sx={{
                                        backgroundColor: "#1976d2",
                                        color: "white",
                                        marginTop: 3,
                                        width: "100%",
                                    }}
                                >
                                    Update
                                </Btn>
                            </Form>
                        )}
                    </Formik>
                </Grid>
            </Grid>
        </>
    );
}

export default ResetPassword;
